import { render, staticRenderFns } from "./uploadFotos.vue?vue&type=template&id=24c60a7c&scoped=true"
import script from "./uploadFotos.vue?vue&type=script&lang=js"
export * from "./uploadFotos.vue?vue&type=script&lang=js"
import style0 from "./uploadFotos.vue?vue&type=style&index=0&id=24c60a7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c60a7c",
  null
  
)

export default component.exports